import { colors } from "../../utils/colors";
import { getPercentageValue } from "../../utils/general";

// Constantes pour les configurations de graphiques
export const createEvolutionChart = (
  label,
  data,
  color,
  withLabels = false
) => {
  const config = {
    type: "line",
    label,
    data,
    color,
  };

  if (withLabels) {
    config.dataLabels2 = [
      {
        display: true,
        align: "top",
        anchor: "top",
        clamp: true,
        font: { size: "8" },
        formatter: (value) => Math.round(value) + "%",
      },
    ];
  }

  return config;
};

export const createDoughnutData = (value, value_globale, typeSearch) => ({
  number: value == null ? value : Math.round(value * 100) / 100,
  text:
    typeSearch !== 4 ? `Globale ${getPercentageValue(value_globale)}` : null,
});

export const createEvolutionCharts = (
  performanceData,
  typeSearch,
  withLabels = false
) => [
  createEvolutionChart(
    `Évolution performance ${performanceData.type}`,
    performanceData.value_month,
    colors["red"][0],
    withLabels
  ),
  createEvolutionChart(
    `Évolution performance ${performanceData.type} globale`,
    typeSearch !== 4 ? performanceData.value_month_globale : null,
    colors["blue"][0],
    withLabels
  ),
];

// Helpers pour formater les lignes de données
export const formatDataRow = (
  label,
  sourceData,
  isPrecisia = false,
  isDelay = false,
  keepZero = false,
  defaultValue = "NC"
) => {
  if (!sourceData) return null;

  const row = [label];
  sourceData.forEach((element, key) => {
    if (!isPrecisia || key !== 2) {
      if (keepZero && element === 0) {
        row.push(0);
      } else {
        row.push(element || (isDelay ? 0 : defaultValue));
      }
    }
  });

  return row;
};

export const swapArrayElements = (arr, index1, index2) => {
  const newArr = [...arr];
  [newArr[index1], newArr[index2]] = [newArr[index2], newArr[index1]];
  return newArr;
};
